import React from 'react';
import { Navigate } from "react-router";

const FrontPage = () => <Navigate to="/rides" />;

export default FrontPage;
